<template>
  <div class="currentCabinHall-container">
    <navbar :showShadow="false" :scrollChange="false" :tabId="3"></navbar>
    <div class="tab-area">
      <div class="tab-wrapper">
        <div
          class="tab"
          :class="{ 'tab--active': currentTab === 1 }"
          @click="switchTab(1)"
        >
          现舱大厅
        </div>
        <div
          class="tab"
          :class="{ 'tab--active': currentTab === 2 }"
          @click="switchTab(2)"
        >
          实单询盘
        </div>
        <div class="split" :style="tabSplitStyle"></div>
        <div class="release-btn-wrapper">
          <div
            id="spaceGuideComponentStep1"
            class="release-btn"
            v-show="currentTab === 1"
            @click="releaseSpace"
          >
            <img src="@/images/common/release_icon.png" />
            <div class="text">我要发布现舱</div>
          </div>
          <div
            id="orderGuideComponentStep1"
            class="release-btn"
            v-show="currentTab === 2"
            @click="releaseOrder"
          >
            <img src="@/images/common/release_icon.png" />
            <div class="text">我要发布询盘</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-area">
      <space-hall
        ref="spaceHallRef"
        :isShow="currentTab === 1"
        v-show="currentTab === 1"
      ></space-hall>
      <order-hall
        ref="orderHallRef"
        :isShow="currentTab === 2"
        v-show="currentTab === 2"
      ></order-hall>
    </div>
    <space-release-dialog
      v-if="showReleaseSpace"
      @close="showReleaseSpace = false"
      @refresh="refreshSpace"
    ></space-release-dialog>
    <order-release-dialog
      v-if="showReleaseOrder"
      @close="showReleaseOrder = false"
      @refresh="refreshOrder"
    ></order-release-dialog>

    <realname-auth-dialog
      v-if="showRealnameAuth"
      @close="showRealnameAuth = false"
      @refresh="() => {}"
    ></realname-auth-dialog>
    <login
      @close="showLogin = false"
      v-if="showLogin"
      @success="() => {}"
      @fail="() => {}"
    ></login>
  </div>
</template>
<script>
import SpaceHall from "./components/space-hall.vue";
import OrderHall from "./components/order-hall.vue";
import { mapState } from "vuex";
export default {
  name: "currentCabinHall",
  data() {
    return {
      currentTab: 1,
      showReleaseSpace: false,
      showReleaseOrder: false,
      showRealnameAuth: false,
      showLogin: false, //登录弹框
    };
  },
  components: {
    SpaceHall,
    OrderHall,
    SpaceReleaseDialog: () => import("./components/space-release-dialog"),
    OrderReleaseDialog: () => import("./components/order-release-dialog"),
    RealnameAuthDialog: () => import("@/components/realname-auth-dialog"),
  },

  watch: {},
  computed: {
    tabSplitStyle() {
      let styleObj = {
        left: "0px",
      };
      switch (this.currentTab) {
        case 1: {
          styleObj.left = "0px";
          break;
        }
        case 2: {
          styleObj.left = `${64 + 74}px`;
          break;
        }
      }
      return styleObj;
    },
    ...mapState("user", {
      userId: (state) => state.userId,
      isAuthentication: (state) => state.isAuthentication,
    }),
  },
  created() {},
  mounted() {},
  methods: {
    switchTab(id) {
      this.currentTab = id;
    },
    // 发布现舱
    releaseSpace() {
      // 检验是否登录
      if (!this.userId) {
        this.showLogin = true;
        return;
      }
      // 检验是否登录
      // 检验是否实名认证 检验是否实名认证 1为已实名 2为未认证
      if(this.isAuthentication != 1){
        this.showRealnameAuth = true;
        return;
      }
      // 检验是否实名认证
      this.showReleaseSpace = true;
    },
    // 发布询盘
    releaseOrder() {
      // 检验是否登录
      if (!this.userId) {
        this.showLogin = true;
        return;
      }
      // 检验是否登录
      // 检验是否实名认证 1为已实名 2为未认证
      if(this.isAuthentication != 1){
        this.showRealnameAuth = true;
        return;
      }
      // 检验是否实名认证
      this.showReleaseOrder = true;
    },
    refreshSpace() {
      this.$refs.spaceHallRef.refreshFilterAndListPublic();
    },
    refreshOrder() {
      this.$refs.orderHallRef.refreshFilterAndListPublic();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variable.scss";
$tabHeight: 68px;
@mixin splitTransition {
  transition: all 0.3s;
}
.currentCabinHall-container {
  padding: $tabHeight + $navbarHeight 0 0 0;
  .tab-area {
    z-index: 99;
    box-shadow: 0px 4px 10px 0px rgba(2, 9, 28, 0.05);
    position: fixed;
    width: 100vw;
    height: $tabHeight;
    top: $navbarHeight;
    left: 0px;
    right: 0px;
    background: #ffffff;
    border-bottom: 1px solid #eff0f4;

    .tab-wrapper {
      height: 100%;
      width: 1200px;
      margin: auto;
      position: relative;
      display: flex;
      align-items: center;
      .tab {
        height: 100%;
        font-size: 16px;
        font-weight: 500;
        color: #676b76;
        margin-right: 74px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &.tab--active {
          color: #373842;
          font-weight: bold;
        }
        &:hover {
          color: #373842;
        }
      }
      .split {
        position: absolute;
        width: 64px;
        height: 4px;
        background: #0081ff;
        border-radius: 3px 3px 0px 0px;
        left: 0px;
        bottom: -1px;
        @include splitTransition();
      }
      .release-btn-wrapper {
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -o-transform: translateY(-50%);

        .release-btn {
          cursor: pointer;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 10px;
          line-height: normal;
          height: 36px;
          background: var(--themeColor);
          // box-shadow: 2px 5px 14px 0px rgba(9, 116, 220, 0.2);
          box-shadow:2px 5px 8px 2px rgba(9, 116, 220, 0.1);
          border-radius: 6px;
          &:hover {
            background: var(--themeHover);
          }

          img {
            width: 24px;
            height: 24px;
            display: block;
            margin-right: 8px;
          }
          .text {
            font-size: 14px;
            font-weight: bold;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>